import React from 'react';
import { Observer } from 'mobx-react-lite';
import { isEmpty, map } from 'lodash';
import Link from '@material-ui/core/Link';
import Table from '@material-ui/core/Table';
import Grid from '@material-ui/core/Grid';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import ParadigmSwitch from '../../../material/switch';
import AddKey from './AddKey';
import TableAction from './TableAction';
import authContext from '../../../stores/auth-store';

const obfuscateKey = (str) => {
  if (str.length > 30) {
    return str.substr(0, 5) + '...' + str.substr(str.length - 5, str.length);
  }
  return str;
};

const KeysTable = (props) => {
  const { source } = props;
  const auth = React.useContext(authContext);
  const [disabledIds, setDisabledIds] = React.useState([]);

  const handleUpdateActiveKey = (key) => {
    setDisabledIds((ids) => [...ids, key.id]);
    key
      .update({
        id: key.id,
        is_enabled: !key.isEnabled,
        entity: key.entity,
        venue: source.shortName,
      })
      .finally(() => setDisabledIds((ids) => ids.filter((i) => i !== key.id)));
  };

  const venueHasDelegatedWallet = !['Thetanuts'].includes(source.name);

  return (
    <Observer>
      {() => (
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left" style={{ width: '50%', minWidth: 155 }}>
                Name
              </TableCell>
              <TableCell align="left" style={{ width: '35%' }}>
                Entity
              </TableCell>
              <TableCell align="left" style={{ width: '30%', minWidth: 210 }}>
                Swap Contract Address
              </TableCell>
              <TableCell align="left" style={{ width: '30%', minWidth: 210 }}>
                Bidding Token Address
              </TableCell>
              <TableCell align="left" style={{ width: '30%', minWidth: 210 }}>
                Wallet Address
              </TableCell>
              {venueHasDelegatedWallet && (
                <TableCell align="left" style={{ width: '30%', minWidth: 210 }}>
                  Delegated Wallet Address
                </TableCell>
              )}
              <TableCell
                style={{ minWidth: 160, maxWith: 160, paddingRight: 0 }}
              >
                Active
              </TableCell>
              {auth.isAdmin && (
                <TableCell align="left" style={{ minWidth: 106 }} />
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {map(source.accessKeys, (key) => (
              <TableRow key={key.id}>
                <TableCell component="th" scope="row">
                  {key.name}
                </TableCell>
                <TableCell component="th" scope="row">
                  {key.entity.name}
                </TableCell>
                <TableCell align="left">
                  {obfuscateKey(key.swap_contract_address)}
                </TableCell>
                <TableCell align="left">
                  {obfuscateKey(key.bidding_token_address)}
                </TableCell>
                <TableCell align="left">
                  {obfuscateKey(key.wallet_address)}
                </TableCell>
                {venueHasDelegatedWallet && (
                  <TableCell align="left">
                    {key.delegated_wallet_address != null && [
                      obfuscateKey(key.delegated_wallet_address ?? ''),
                    ]}
                  </TableCell>
                )}
                <TableCell align="left" style={{ paddingRight: 0 }}>
                  <Grid container alignItems="center">
                    <Grid item>
                      <ParadigmSwitch
                        disabled={
                          !(auth.isAdmin || auth.isTrader) ||
                          disabledIds.includes(key.id)
                        }
                        checked={Boolean(key.isEnabled)}
                        onChange={() => handleUpdateActiveKey(key)}
                      />
                    </Grid>
                    <Grid item>
                      <Typography
                        color="textSecondary"
                        style={{ marginLeft: 10 }}
                      >
                        {key.isEnabled ? 'Active' : ''}
                      </Typography>
                    </Grid>
                  </Grid>
                </TableCell>
                {auth.isAdmin && (
                  <TableCell align="left">
                    <TableAction apiKey={key} source={source} />
                  </TableCell>
                )}
              </TableRow>
            ))}
            {isEmpty(source.accessKeys) && (
              <TableRow hover={false}>
                <TableCell align="center" colSpan={auth.isAdmin ? 7 : 4}>
                  No Wallet address found.&nbsp;
                  <AddKey
                    source={source}
                    children={
                      <Link variant="body1" color="primary">
                        Click here to add one
                      </Link>
                    }
                  />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      )}
    </Observer>
  );
};

export default KeysTable;
